module.exports = __webpack_public_path__ + "img/QUECHU.39a5a3b2.svg";